<template>
  <nav class="menu-container">

    <RouterLink
      :exact="item.exact"
      v-for="item in items"
      :key="item.link"
      :to="{ name: item.name }"
      active-class="selected"
      exact-active-class=""
    >
      <div class="icon">
        <Icon :type="item.icon" />
      </div>
      <span>{{ item.title }}</span>
    </RouterLink>
    安托山站<br>
站点介绍<br>
安托山站位于侨香四道与远期规划的安托山四路交叉路口，沿侨香四道东西向布置，临近侨香三道与安托山六路。东南方向为深国投广场，设有购物中心、山姆会员店、肯德基等餐饮娱乐，为周边小区提供一站式休闲与购物。周边为高尚小区，东面为锦庐花园住宅区；南面为雅福居住宅区，东北面是听泉居住宅区。 该站为地下站。<br><br>
运营时刻表(工作日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
赤湾	06:28	00:08	2号线	2分35秒	5分45秒<br>
莲塘	06:01	23:33	2号线	2分35秒	5分45秒<br>
西丽湖	06:42	23:41	7号线	3分35秒	5分55秒<br>
太安	06:01	23:16	7号线	3分35秒	5分55秒<br><br>
运营时刻表(休息日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
赤湾	06:32	00:07	2号线	4分钟	5分钟<br>
莲塘	06:01	23:33	2号线	4分钟	5分钟<br>
西丽湖	06:36	23:41	7号线	4分钟	5分55秒<br>
太安	06:08	23:16	7号线	4分钟	5分55秒<br><br>
运营时刻表(节假日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
赤湾	06:32	00:57	2号线	4分钟	5分钟<br>
莲塘	06:01	00:33	2号线	4分钟	5分钟<br>
西丽湖	06:36	00:41	7号线	4分钟	5分55秒<br>
太安	06:08	00:16	7号线	4分钟	5分55秒<br><br>
<br>
站点出口信息<br><br>
A出入口:<br>
侨香四路东侧、安峦公馆<br><br>
B出入口:<br>
侨香三道、牛剑教育<br><br>
C出入口:<br>
听泉居、雅福居、锦庐花园、万科臻山府、侨香四道<br><br>
D出入口:<br>
侨香四道（西）<br><br>
E出入口:<br>
（暂未开通）安托山四路<br><br>
公交换乘信息<br><br>
B出入口:<br>
公交站名： 侨香三道<br>
107、72、N24<br>
</nav>
</template>

<script>
// import Icon from "@/components/Icon";
export default {
  components: {
    // Icon,
  },
  data() {
    return {
      items: [
        {
          name: "erhaoxian",
          title: "2号线",
          // icon: "chat",
          exact: true,
        },
        {
          name: "qihaoxian",
          title: "7号线",
          // icon: "chat",
          exact: true,
        },
      ],
    };
  },
};
</script>

<style scoped lang="less">
@import "~@/styles/var.less";
.menu-container {
  color: @words;
  margin: 24px 0;
  a {
    &.selected {
      background: darken(@words, 3%);
    }
    padding: 0 50px;
    display: block;
    display: flex;
    align-items: center;
    height: 45px;
    // .icon {
    //   width: 24px;
    // }
    &:hover {
      color: rgb(50, 95, 227);
    }
  }
}
</style>